import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayEditLocNames =
	| 'SPSettingsScoreReportDelayEditTitle'
	| 'SPSettingsScoreReportDelayEditConfirm'
	| 'SPSettingsScoreReportDelayEditCancel';

export const spSettingsScoreReportDelayEditLocs: LocDefs<SPSettingsScoreReportDelayEditLocNames> = {
	SPSettingsScoreReportDelayEditTitle: {
		defaultValue: 'Edit Delay Setting',
		description: 'Title for the score report edit setting dialog.',
		displayPath: `${pathStart}Edit Dialog Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayEditConfirm: {
		defaultValue: 'Edit Delay Setting',
		description: 'Confirm button for the score report edit setting dialog.',
		displayPath: `${pathStart}Edit Dialog|Confirm`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayEditCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button for the score report edit setting dialog.',
		displayPath: `${pathStart}Edit Dialog|Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPSettingsScoreReportDelayEditLocType = LocMap<SPSettingsScoreReportDelayEditLocNames>;
